module.exports = __webpack_public_path__ + "assets/images/covid-hits-home-8.jpg?v=75e310b4";